import React, { useState, useEffect } from "react";
import {
  descargarPrevisualizador,
  setMessageError,
  setMessageSuccess,
  setPrevisualizador,
} from "../sliceRedux/ValidarReserva.slice";
import RenderToast from "./RenderToast";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Observation from "./Observation";
import { Button } from "primereact/button";

const PreviewPDF = ({
  toast,
  showLoader,
  hideLoader,
  dispatch,
  codSolConstitucion,
  codSolReservaDenominacion,
  codGrupoConstAdec,
  navigate,
}) => {
  const location = useLocation();
  const previsualizador = useSelector((state) => state.validar.previsualizador);
  const messageError = useSelector((state) => state.validar.messageError);
  const messageSuccess = useSelector((state) => state.validar.messageSuccess);

  const [pdfURL, setPdfURL] = useState("");
  const [pdfBlob, setPdfBlob] = useState(null);

  useEffect(() => {
    showLoader();
    const data = {
      codSolicitudConstitucion: codSolConstitucion,
      codSolicitudReserva: codSolReservaDenominacion,
      codGrupoAde: codGrupoConstAdec,
    };
    dispatch(descargarPrevisualizador(data));
  }, []);

  useEffect(() => {
    let objectUrl;
    if (previsualizador.code === 200) {
      const { blob, url } = base64ToPdf(previsualizador?.object?.archivoPdf);
      setPdfBlob(blob);
      setPdfURL(url);
    }
    return () => {
      hideLoader();
      dispatch(setPrevisualizador({ ...previsualizador, code: 0 }));
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [previsualizador.code]);

  useEffect(() => {
    if (messageSuccess !== "") {
      RenderToast(toast, "success", "Éxito", messageSuccess);
      setTimeout(() => {
        navigate("/solicitudes-constitucion", { state: { ...location.state } });
      }, 2000);
    }
    return () => {
      hideLoader();
      dispatch(setMessageSuccess(""));
    };
  }, [messageSuccess]);

  useEffect(() => {
    if (messageError !== "") {
      RenderToast(toast, "error", "Error", messageError);
    }
    return () => {
      hideLoader();
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  const base64ToPdf = (base64) => {
    try {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      return { blob, url };
    } catch (error) {
      console.error("Error creando PDF:", error);
      return { blob: null, url: "" };
    }
  };

  const handleDownload = () => {
    if (!pdfBlob) return;
    const url = URL.createObjectURL(pdfBlob);
    const link = document.createElement("a");
    link.href = url;
    const fileName =
      previsualizador?.object?.nombreArchivoPdf ||
      `Previsualizacion_${new Date().toISOString().replace(/[:.-]/g, "")}.pdf`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="card">
      <Observation
        observationValue={previsualizador?.object?.observacion}
        showLoader={showLoader}
        dispatch={dispatch}
      />

      {pdfURL && (
        <>
          <iframe
            src={`${pdfURL}#toolbar=0&navpanes=0&scrollbar=0`}
            title="Visualizar PDF"
            width="100%"
            height="600px"
          />
          <div className="mt-3 flex justify-content-center">
            <Button
              label="Descargar PDF"
              icon="pi pi-download"
              iconPos="left"
              onClick={handleDownload}
              className="p-button p-component"
            ></Button>
          </div>
        </>
      )}
    </div>
  );
};

export default PreviewPDF;
